<template>
    <div class="destina">
        <el-button class="back down-file-btn" size="mini" type="primary" @click="back()">
            <i class="el-icon-arrow-left el-icon--right"></i>
            返回主列表
        </el-button>
        <el-tabs tab-position="top" @tab-click="removesearch">
<!--            <el-tab-pane label="基本信息">-->
<!--                <baseMsg></baseMsg>-->
<!--            </el-tab-pane>-->
            <el-tab-pane label="推荐景区">
                <scenicList :areaCode="areaCode" :id="id"></scenicList>
            </el-tab-pane>
            <el-tab-pane label="推荐农家乐">
                <agritainment :areaCode="areaCode" :id="id"></agritainment>
            </el-tab-pane>
            <el-tab-pane label="推荐攻略">
                <strategy :areaCode="areaCode" :id="id"></strategy>
            </el-tab-pane>
            <el-tab-pane label="推荐游记">
                <travel :areaCode="areaCode" :id="id"></travel>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>
<script>
    import scenicList from '../classify/scenic'
    // import baseMsg from '../components/baseMsg'
    import strategy from '../classify/strategy'
    import agritainment from '../classify/agritainment'
    import travel from '../classify/travel'

    export default {
        name: 'scenicForm',
        components: {
            scenicList,
            strategy,
            agritainment,
            travel
        },
        data () {
            return {
                areaCode: '',
                userType: '',
                id:''
            }
        },
        methods:{


             removesearch(){
                 this.request.removeSession('searchinfo')
             },
            back(){
                this.$router.back(-1)
            }
        },
        created: function () {
            debugger
            this.areaCode = this.$route.query.areaCode
            this.id = this.$route.query.id
        },
        mounted () {
        },

        updated () {
        }

    }
</script>
<style lang="less" scoped>
    .back{
        position: absolute;
        top: 0;
        right: 10px;
        z-index: 99;
    }
</style>
<style lang="less">
    .destina{
        position: relative;
        .el-tabs--right {
            .el-tabs__header.is-right {
                margin-bottom: 0;
                margin-left: 0;
                position: fixed;
                right: 34px;
                height: auto !important;
                z-index: 1;
            }
            .el-tabs__content {
                padding-right: 114px;
                overflow: auto;
            }
        }

        .el-tabs__content {
            overflow: hidden;
            position: relative;

        }
        .el-tab-pane,.el-tabs--right,.el-tabs__content{
            height: 100%;
        }
    }
</style>
